import packageJson from './package.json';
import servers from './dist/servers.json';

export async function startAgent(initAgent, options = {}) {
    if (!options.apiKey) exit('Missing required option "apiKey"');

    const server = await getServerConfig(options);
    delete options.config;

    const pendo = initAgent(server);
    const globalKey = options.globalKey || 'pendo';
    window[globalKey] = pendo;
    delete options.globalKey;

    addPlugins(pendo, options);
    delete options.plugins;

    pendo.initialize(options);

    return pendo;
}

export async function getServerConfig(options) {
    if (!options.env) exit('Missing option "env", please specify an environment for your Pendo subscription.');
    let config;
    if (!options.config || !Object.keys(options.config).length) {
        const baseConfig = generateBaseAgentConfig(options.env);
        const configUrl = new URL(`agent/static/${options.apiKey}/config.json`, `https://${baseConfig.assetHost}`).toString();
        const serverConfig = await fetch(configUrl)
            .then(response => {
                if (!response.ok) exit('could not load config.json');
                return response.json();
            });
        config = {
            ...serverConfig,
            ...baseConfig
        };
    } else {
        config = {
            ...options.config,
            ...generateBaseAgentConfig(options.env)
        };
    }

    if (options.assets) {
        options.assetHost = options.assets.host;
        config.assetPath = options.assets.path;
        delete config.assetHost;
        options.recording = {
            ...options.recording,
            'workerUrl': `${options.assetHost ? options.assetHost : ''}${config.assetPath ? '/' + config.assetPath : ''}/replay.worker.min.js`
        };
        if (options.assets.localOnly) {
            config.preventCodeInjection = true;
            config.disableDesigner = true;
        }

        delete options.assets;
    } else {
        config.assetPath = `agent/releases/${packageJson.version}`;
    }
    if (options.globalKey) {
        config.pendoGlobalKey = options.globalKey;
    }
    config.loadAsModule = true;
    delete config.stagingAgentUrl;
    delete config.stagingServerHashes;
    delete config.stagingServers;

    return config;
}

function exit(message, error) {
    throw new Error(`Failed to load Pendo agent: ${message}`, { 'cause': error });
}

function addPlugins(pendo, options) {
    [].concat(options.plugins).forEach(plugin => {
        if (!plugin) return;
        if (typeof plugin === 'function') {
            plugin = plugin();
        }
        pendo.addExtension({
            'name':    plugin.name,
            'version': '1.0.0',
            'type':    'agent',
            'use':     'plugin',
            'uri':     plugin
        });
    });
}

function generateBaseAgentConfig(env) {
    if (!servers.ENV[env]) {
        exit(`Unknown environment "${env}", please specify a valid environment for your subscription.`);
    }
    return {
        'env':         servers.ENV[env],
        'designerEnv': servers.ENV[env],
        'server':      servers.data[env],
        'assetHost':   servers.assetHost[env]
    };
}
